import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BatchesModel } from 'common/models/page-models/Batches/batches-data-model';
import { BatchesListingModel } from 'common/models/page-models/Batches/batches-grid-model';
// import { BatchesListingModel, BatchesModel } from 'common/models/page-models/batches-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { BatchesGridWidgetService } from 'common/widget/batches/batches-grid-widget.services';
 
@Injectable({
    providedIn: 'root'
})
export class BatchesGridResolver extends GridResolver<BatchesModel, BatchesListingModel> {
    constructor(
        protected fs: BatchesGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}